import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export default function CartProvider({ children }) {
    // items: [{ product, selections, quantity, totalPrice }]
    const [cartItems, setCartItems] = useState([]);

    function addItem(item) {
        setCartItems(prev => {
            const existingIndex = prev.findIndex(existing =>
                existing.product.id === item.product.id &&
                JSON.stringify(existing.selections) === JSON.stringify(item.selections)
            );
            if (existingIndex >= 0) {
                return prev.map((existing, i) =>
                    i === existingIndex
                        ? { ...existing, quantity: existing.quantity + item.quantity }
                        : existing
                );
            }
            return [...prev, item];
        });
    }

    function removeItem(index) {
        setCartItems(prev => prev.filter((_, i) => i !== index));
    }

    function clearCart() {
        setCartItems([]);
    }

    const cartTotal = cartItems.reduce((sum, item) => sum + item.totalPrice * item.quantity, 0);

    return (
        <CartContext.Provider value={{ cartItems, addItem, removeItem, clearCart, cartTotal }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error('useCart must be used within CartProvider');
    return ctx;
}
